import { DynamicFormV2Palette } from "@mui/material";

export type FormDateComponentTokenType = {
  textColor: string;
  calendarSquareTextColor: string;
  calendarSquareBackgroundColor: string;
  calendarSquareMonthBackgroundColor: string;
  calendarSquareBorderColor: string;
};

export const assignDateComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    textColor: formsPalette.text.moderate,
    calendarSquareTextColor: formsPalette.text.moderate,
    calendarSquareBackgroundColor: isLightMode ? formsPalette.surface.supershy : formsPalette.surface.quiet,
    calendarSquareMonthBackgroundColor: isLightMode ? formsPalette.border.moderate : formsPalette.surface.supershy, // We make an exception here, as we are using a border token as the background color
    calendarSquareBorderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.brand,
  } as FormDateComponentTokenType;
};
